'use client';

import * as React from 'react';
import { cn } from '@/lib/utils';
import { Skeleton } from '@/components/ui';

interface ProductSkeletonProps {
  className?: string;
}

/**
 * Skeleton loader for ProductCard
 */
export function ProductSkeleton({ className }: ProductSkeletonProps) {
  return (
    <div
      className={cn(
        // Те же токены, что у настоящей карточки товара: скелетон не должен
        // светить чистым белым на углублённом фоне светлой темы (ответ 34 = Б).
        'bg-[var(--surface-primary)]',
        'border border-[var(--border-default)]',
        'rounded-card overflow-hidden',
        className
      )}
    >
      {/* Image skeleton */}
      <Skeleton className="aspect-square w-full rounded-none" />

      {/* Content skeleton */}
      <div className="p-3 flex flex-col gap-2">
        {/* Title */}
        <Skeleton className="h-4 w-3/4" />

        {/* Weight */}
        <Skeleton className="h-3 w-1/3" />

        {/* Price button */}
        <Skeleton className="h-9 w-full rounded-card mt-1" />
      </div>
    </div>
  );
}

/**
 * Grid of skeleton cards
 */
interface ProductSkeletonGridProps {
  count?: number;
  className?: string;
}

export function ProductSkeletonGrid({ count = 8, className }: ProductSkeletonGridProps) {
  return (
    <div
      className={cn(
        'grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-4',
        className
      )}
    >
      {Array.from({ length: count }).map((_, index) => (
        <ProductSkeleton key={index} />
      ))}
    </div>
  );
}

